"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import React from "react";
import { action, computed, observable, runInAction, toJS } from "mobx";
import { observer } from "mobx-react";
import Tooltip, { TooltipSize } from "../Tooltip/Tooltip";
import ErrorTooltip from "../Tooltip/ErrorTooltip";
import TextInput, { TextInputType } from "../TextInput/TextInput";
import Dropdown from "../dropdown/Dropdown/Dropdown";
import DropdownItem from "../dropdown/DropdownItem/DropdownItem";
import { RadioGroup, RadioGroupItem } from "../RadioGroup/RadioGroup";
import Button from "../Button/Button";
import classNames from "classnames";
import { OptionGroupSize, StricterOptionGroup } from "../OptionGroup/OptionGroup";
import { FormType, FormWidth, FormInputSize } from "./Types";
export { FormType, FormWidth, FormInputSize } from "./Types";
var DEFAULT_TEXT_INPUT_MAX_LENGTH = 1e3;
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  var _super = _createSuper(Form);
  function Form(props) {
    var _this;
    _classCallCheck(this, Form);
    _this = _super.call(this, props);
    _this.dropdownValues = {};
    _this.textValues = {};
    _this.radioValues = {};
    _this.optionValues = {};
    _this.shouldShowError = false;
    _this.submitCount = 0;
    _this.isSubmitting = false;
    _this.externalError = "";
    _this.getDropdownValue = function (field) {
      var _a, _b, _c;
      var dropdownState = _this.getDropdownState(field);
      return (_c = (_b = dropdownState.otherText) != null ? _b : (_a = dropdownState.option) == null ? void 0 : _a.id) != null ? _c : "";
    };
    _this.getDropdownState = function (field) {
      var otherOption = field.options.find(function (option) {
        return option.isOtherOption;
      });
      if (_this.props.dataStore) {
        var externalValue = _this.getValue(field.id);
        if (!!externalValue) {
          var externalOption = field.options.find(function (option) {
            return option.id === externalValue;
          });
          if (externalOption) {
            return {
              option: externalOption
            };
          }
          if (!externalOption && otherOption) {
            return {
              option: otherOption,
              otherText: externalValue
            };
          }
          if (!externalOption && !otherOption) {
            return {};
          }
        }
        if (!externalValue) {
          var internalValue2 = _this.getValue(field.id, FormType.Dropdown, true);
          var internalOption2 = field.options.find(function (option) {
            return option.id === internalValue2;
          });
          if (internalOption2 && internalOption2 === otherOption) {
            return {
              option: internalOption2,
              otherText: ""
            };
          }
          return {};
        }
      }
      var internalValue = _this.getValue(field.id, FormType.Dropdown, true);
      var internalOtherValue = _this.getValue(field.id, FormType.Text, true);
      var internalOption = field.options.find(function (option) {
        return option.id === internalValue;
      });
      if (internalOption && internalOption !== otherOption) {
        return {
          option: internalOption
        };
      }
      if (internalOption && internalOption === otherOption) {
        return {
          option: internalOption,
          otherText: internalOtherValue
        };
      }
      return {};
    };
    _this.isSubmitKeyEvent = function (event) {
      var nodeName = event.target.nodeName;
      return event.key == "Enter" && nodeName.toLowerCase() != "textarea";
    };
    _this.maybeSubmit = function (event) {
      if (_this.isSubmitKeyEvent(event) && !_this.isSubmitting) {
        if (_this.props.allowDevAutocomplete) {
          for (var i = 0; i < _this.props.fields.length; i++) {
            var field = _this.props.fields[i];
            if (field.type === FormType.Text) {
              if (!_this.getValue(field.id, field.type)) {
                if (field.props.type === TextInputType.Email) {
                  _this.setValue(field.type, field.id, getRandomEmail(field.props.placeholder || ""));
                } else {
                  _this.setValue(field.type, field.id, field.props.placeholder || "");
                }
              }
            } else if (field.type === FormType.OptionGroup) {
              if (!_this.getValue(field.id, field.type)) {
                _this.setValue(field.type, field.id, field.props.options[0].value);
              }
            } else if (field.type === FormType.Radio) {
              if (!_this.getValue(field.id, field.type)) {
                _this.setValue(field.type, field.id, field.props.options[0].value);
              }
            } else {
              if (!_this.getValue(field.id, field.type) && field.options) {
                _this.setValue(field.type, field.id, field.options[0].id);
              }
            }
          }
        }
        _this.onSubmit();
      }
    };
    return _this;
  }
  _createClass(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.showEnterKeyPrompt) {
        window.document.addEventListener("keyup", this.maybeSubmit);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.showEnterKeyPrompt) {
        window.document.removeEventListener("keyup", this.maybeSubmit);
      }
    }
  }, {
    key: "setValue",
    value: function setValue(fieldType, fieldId, value) {
      var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref$isOtherOption = _ref.isOtherOption,
        isOtherOption = _ref$isOtherOption === void 0 ? false : _ref$isOtherOption;
      var _a;
      switch (fieldType) {
        case FormType.Text:
          {
            this.textValues[fieldId] = value;
            break;
          }
        case FormType.Dropdown:
          {
            this.dropdownValues[fieldId] = value;
            break;
          }
        case FormType.Radio:
          {
            this.radioValues[fieldId] = value;
            break;
          }
        case FormType.OptionGroup:
          {
            this.optionValues[fieldId] = value;
            break;
          }
      }
      if (this.props.dataStore) {
        if (isOtherOption) {
          this.props.dataStore.setById(fieldId, (_a = this.textValues[fieldId]) != null ? _a : "");
        } else {
          this.props.dataStore.setById(fieldId, value);
        }
      }
      if (this.shouldShowError) {
        this.shouldShowError = false;
      }
    }
  }, {
    key: "values",
    get: function get() {
      var _this2 = this;
      var values = {};
      this.props.fields.forEach(function (field) {
        if (field.type === FormType.Dropdown) {
          values[field.id] = _this2.getDropdownValue(field);
        } else {
          values[field.id] = _this2.getValue(field.id, field.type);
        }
      });
      return values;
    }
  }, {
    key: "getValue",
    value: function getValue(fieldId, fieldType, alwaysUseInternalValue) {
      var _this3 = this;
      if (this.props.dataStore && !alwaysUseInternalValue) {
        return this.props.dataStore.getById(fieldId);
      } else {
        return computed(function () {
          switch (fieldType) {
            case FormType.Text:
              {
                return _this3.safeGetValue(_this3.textValues, fieldId);
              }
            case FormType.Dropdown:
              {
                return _this3.safeGetValue(_this3.dropdownValues, fieldId);
              }
            case FormType.Radio:
              {
                return _this3.safeGetValue(_this3.radioValues, fieldId);
              }
            case FormType.OptionGroup:
              {
                return _this3.safeGetValue(_this3.optionValues, fieldId);
              }
            default:
              {
                return _this3.safeGetValue(_this3.textValues, fieldId) || _this3.safeGetValue(_this3.dropdownValues, fieldId) || _this3.safeGetValue(_this3.radioValues, fieldId) || _this3.safeGetValue(_this3.optionValues, fieldId) || "";
              }
          }
        }).get();
      }
    }
  }, {
    key: "safeGetValue",
    value: function safeGetValue(valuesStore, fieldId) {
      return valuesStore[fieldId] || "";
    }
  }, {
    key: "isValid",
    get: function get() {
      var enableSubmission = this.props.enableSubmission;
      var isValid = true;
      var submissionAllowed = enableSubmission != null ? enableSubmission : true;
      var _iterator2 = _createForOfIteratorHelper(this.props.fields),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var field = _step2.value;
          var value = field.type === FormType.Dropdown ? this.getDropdownValue(field) : this.getValue(field.id);
          var errorMessage = field.validate(value);
          isValid = isValid && !errorMessage;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return isValid && submissionAllowed;
    }
  }, {
    key: "errorField",
    get: function get() {
      var result;
      for (var i = 0; i < this.props.fields.length; i++) {
        var field = this.props.fields[i];
        var value = field.type === FormType.Dropdown ? this.getDropdownValue(field) : this.getValue(field.id);
        var errorMessage = field.validate(value);
        if (errorMessage) {
          result = field;
          break;
        }
      }
      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var endElement = this.props.endElement;
      var onFormKeyUp = !this.props.showEnterKeyPrompt ? this.maybeSubmit : void 0;
      return /* @__PURE__ */React.createElement("div", {
        className: classNames("form form--kl", "form--".concat(this.props.width), this.props.className),
        onKeyUp: onFormKeyUp
      }, this.fields, !!endElement && endElement, !this.props.hideSubmitButton && /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("div", {
        className: "form__button-spacer"
      }), /* @__PURE__ */React.createElement("div", {
        className: classNames("form__button-with-prompt", {
          "form__button-with-prompt--with-enter-key": this.props.showEnterKeyPrompt,
          "form__button-with-prompt--single-action": !this.props.showEnterKeyPrompt
        })
      }, /* @__PURE__ */React.createElement(ErrorTooltip, {
        renderTooltip: !!this.externalError,
        content: this.externalError || "",
        size: TooltipSize.Large
      }, /* @__PURE__ */React.createElement("div", {
        className: "form__button-wrapper",
        onMouseEnter: this.onMouseEnter
      }, /* @__PURE__ */React.createElement(Button, {
        className: "form__button",
        onClick: this.onSubmit,
        size: this.props.inputSize,
        disabled: !this.isValid,
        "data-synthetics-selector": "form-button"
      }, this.props.buttonText))), this.props.showEnterKeyPrompt && /* @__PURE__ */React.createElement("div", {
        className: "form__enter-key"
      }, "or press \u2018Enter\u2019 key"))));
    }
  }, {
    key: "fields",
    get: function get() {
      var _this4 = this;
      return /* @__PURE__ */React.createElement(React.Fragment, null, this.props.fields.map(function (field, index) {
        return /* @__PURE__ */React.createElement("div", {
          key: index,
          "data-fieldid": field.id
        }, _this4.renderField(field), index !== _this4.props.fields.length - 1 && /* @__PURE__ */React.createElement("div", {
          className: "form__spacer"
        }));
      }));
    }
  }, {
    key: "renderField",
    value: function renderField(field) {
      var _a, _b;
      var value = field.type === FormType.Dropdown ? this.getDropdownValue(field) : this.getValue(field.id);
      var shouldShowError = this.shouldShowError && this.errorField && this.errorField.id == field.id;
      var errorMessage = field.validate(value) || "";
      if (field.type === FormType.Text) {
        return /* @__PURE__ */React.createElement(Tooltip, {
          isError: true,
          content: errorMessage,
          size: TooltipSize.Large,
          show: shouldShowError
        }, this.renderTextInput(field));
      } else if (field.type === FormType.Dropdown) {
        var selectedId = (_b = (_a = this.getDropdownState(field).option) == null ? void 0 : _a.id) != null ? _b : "";
        var showOtherTextInput = isDropdownOtherSelected(selectedId, field) && field.showOtherTextInput;
        return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(Tooltip, {
          isError: true,
          content: errorMessage,
          size: TooltipSize.Large,
          show: !showOtherTextInput && shouldShowError
        }, this.renderDropdown(field)), isDropdownOtherSelected(selectedId, field) && field.showOtherTextInput && /* @__PURE__ */React.createElement(Tooltip, {
          isError: true,
          content: errorMessage,
          size: TooltipSize.Large,
          show: shouldShowError
        }, this.renderDropdownOtherTextInput(field)));
      } else if (field.type === FormType.Radio) {
        return /* @__PURE__ */React.createElement(Tooltip, {
          isError: true,
          content: errorMessage,
          size: TooltipSize.Large,
          show: shouldShowError
        }, this.renderRadioGroup(field));
      } else if (field.type === FormType.OptionGroup) {
        return /* @__PURE__ */React.createElement(Tooltip, {
          isError: true,
          content: errorMessage,
          size: TooltipSize.Large,
          show: shouldShowError
        }, this.renderOptionGroup(field));
      }
    }
  }, {
    key: "renderTextInput",
    value: function renderTextInput(field) {
      var _this5 = this;
      var _a;
      return /* @__PURE__ */React.createElement(TextInput, __spreadProps(__spreadValues({
        size: this.props.inputSize
      }, field.props), {
        value: this.getValue(field.id),
        onChange: function onChange(value) {
          _this5.setValue(field.type, field.id, value);
        },
        maxLength: (_a = field.maxTextInputLength) != null ? _a : DEFAULT_TEXT_INPUT_MAX_LENGTH
      }));
    }
  }, {
    key: "renderDropdown",
    value: function renderDropdown(field) {
      var _this6 = this;
      var _a, _b;
      var dropdownName = (_b = (_a = this.getDropdownState(field).option) == null ? void 0 : _a.name) != null ? _b : "";
      return /* @__PURE__ */React.createElement(Dropdown, __spreadProps(__spreadValues({
        size: this.props.inputSize
      }, field.props), {
        name: dropdownName
      }), (field.options || []).map(function (option, index) {
        return /* @__PURE__ */React.createElement(DropdownItem, {
          key: index,
          name: option.name,
          selected: dropdownName === option.name,
          onSelect: function onSelect() {
            _this6.setValue(FormType.Dropdown, field.id, option.id, {
              isOtherOption: option.isOtherOption
            });
          }
        });
      }));
    }
  }, {
    key: "renderDropdownOtherTextInput",
    value: function renderDropdownOtherTextInput(field) {
      var _this7 = this;
      var _a, _b;
      return /* @__PURE__ */React.createElement(TextInput, __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, field.props), {
        labelHidden: true,
        label: "Other",
        size: this.props.inputSize
      }), field.otherTextInputProps), {
        className: "form__other-for-dropdown",
        value: (_a = this.getDropdownState(field).otherText) != null ? _a : "",
        onChange: function onChange(value) {
          _this7.setValue(FormType.Text, field.id, value);
        },
        maxLength: (_b = field.maxTextInputLength) != null ? _b : DEFAULT_TEXT_INPUT_MAX_LENGTH
      }));
    }
  }, {
    key: "renderRadioGroup",
    value: function renderRadioGroup(field) {
      var _this8 = this;
      return /* @__PURE__ */React.createElement(RadioGroup, __spreadProps(__spreadValues({}, field.props), {
        value: this.getValue(field.id),
        onChange: function onChange(value) {
          _this8.setValue(field.type, field.id, value);
        }
      }), field.props.options.map(function (option) {
        return /* @__PURE__ */React.createElement(RadioGroupItem, {
          key: option.value,
          label: option.label,
          value: option.value,
          disabled: option.disabled
        });
      }));
    }
  }, {
    key: "renderOptionGroup",
    value: function renderOptionGroup(field) {
      var _this9 = this;
      return /* @__PURE__ */React.createElement(StricterOptionGroup, __spreadProps(__spreadValues({}, field.props), {
        size: OptionGroupSize.Large,
        selectedValue: this.getValue(field.id, FormType.OptionGroup),
        onClickHandler: function onClickHandler(value) {
          _this9.setValue(field.type, field.id, value);
        }
      }));
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.isSubmitting) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              if (!this.isValid) {
                _context.next = 21;
                break;
              }
              _context.prev = 5;
              this.setIsSubmitting(true);
              this.externalError = "";
              _context.next = 10;
              return this.props.onComplete(toJS(this.values));
            case 10:
              _context.next = 16;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);
              this.externalError = _context.t0.message;
              throw _context.t0;
            case 16:
              _context.prev = 16;
              this.setIsSubmitting(false);
              return _context.finish(16);
            case 19:
              _context.next = 23;
              break;
            case 21:
              this.showError();
              throw new Error();
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 12, 16, 19]]);
      }));
    }
  }, {
    key: "setIsSubmitting",
    value: function setIsSubmitting(isSubmitting) {
      this.isSubmitting = isSubmitting;
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter() {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.isValid) {
                this.showError();
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "showError",
    value: function showError() {
      var _this10 = this;
      var submitCount = ++this.submitCount;
      this.shouldShowError = true;
      setTimeout(function () {
        runInAction(function () {
          if (_this10.submitCount === submitCount) {
            _this10.shouldShowError = false;
          }
        });
      }, 3500);
    }
  }]);
  return Form;
}(React.Component);
Form.defaultProps = {
  width: FormWidth.Normal,
  allowDevAutocomplete: false,
  buttonText: "Submit",
  showEnterKeyPrompt: false,
  inputSize: FormInputSize.Large
};
__decorateClass([observable.deep], Form.prototype, "dropdownValues", 2);
__decorateClass([observable.deep], Form.prototype, "textValues", 2);
__decorateClass([observable.deep], Form.prototype, "radioValues", 2);
__decorateClass([observable.deep], Form.prototype, "optionValues", 2);
__decorateClass([observable.ref], Form.prototype, "shouldShowError", 2);
__decorateClass([observable.ref], Form.prototype, "submitCount", 2);
__decorateClass([observable.ref], Form.prototype, "isSubmitting", 2);
__decorateClass([observable.ref], Form.prototype, "externalError", 2);
__decorateClass([action.bound], Form.prototype, "setValue", 1);
__decorateClass([computed], Form.prototype, "values", 1);
__decorateClass([computed], Form.prototype, "isValid", 1);
__decorateClass([computed], Form.prototype, "errorField", 1);
__decorateClass([computed], Form.prototype, "fields", 1);
__decorateClass([action.bound], Form.prototype, "onSubmit", 1);
__decorateClass([action.bound], Form.prototype, "setIsSubmitting", 1);
__decorateClass([action.bound], Form.prototype, "onMouseEnter", 1);
__decorateClass([action.bound], Form.prototype, "showError", 1);
Form = __decorateClass([observer], Form);
var getRandomEmail = function getRandomEmail(baseEmail) {
  return baseEmail.replace(/@.+$/, "".concat(Math.floor(Math.random() * 99999999), "@testing.com"));
};
var isDropdownOtherSelected = function isDropdownOtherSelected(selectedValue, field) {
  var _a;
  return !!((_a = field.options.find(function (f) {
    return f.id === selectedValue;
  })) == null ? void 0 : _a.isOtherOption);
};
export default Form;